var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99 99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ed2831;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 99,
    height: 99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.65,21.65H45.86a14.4,14.4,0,1,0,0,28.79h11a6.43,6.43,0,0,0-6.16-4.8h-4.8a9.6,9.6,0,1,1,0-19.19H66.65a9.6,9.6,0,0,1,.4,19.19,16.25,16.25,0,0,1,1.12,4.72,14.39,14.39,0,0,0-1.52-28.71ZM63.13,44.84A14.06,14.06,0,0,1,65.05,52a14.43,14.43,0,0,1-14.39,14.4H29.86a14.4,14.4,0,0,1-1.52-28.71,19.35,19.35,0,0,0,1.12,4.71,9.6,9.6,0,0,0,.4,19.2h20.8a9.6,9.6,0,0,0,0-19.2h-4.8a6.43,6.43,0,0,1-6.16-4.79h11A14.51,14.51,0,0,1,63.13,44.84Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinks);
export default __webpack_public_path__ + "static/media/links.f459eb8569433af342a3f8a3f7a873ac.svg";
export { ForwardRef as ReactComponent };